import Nullstack from 'nullstack';
export default function IconAdjustments({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-adjustments",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "10",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "4",
    x2: "6",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "12",
    x2: "6",
    y2: "20"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "16",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "4",
    x2: "12",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "20"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "4",
    x2: "18",
    y2: "5"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "9",
    x2: "18",
    y2: "20"
  }), " ");
}